import { PaginationParams } from 'api/api';

export type ItemsEntity<T> = {
    items: T[];
};

export type PaginationData = {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
};

export type PaginationResponse<T> = ItemsEntity<T> & PaginationData;

export type PaginationProps = PaginationParams;

export function isPaginationResponse<T>(
    response: PaginationResponse<T> | T[]
): response is PaginationResponse<T> {
    return typeof response === 'object' && 'items' in response;
}

export type ExtractPaginationResponse<T> =
    AwaitedResult<T> extends PaginationResponse<infer U>
        ? U
        : ExtractPromisedElement<T>;
